import { createContext, useContext, useEffect, useState } from "react";
import { strings } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("li_lang") || "en");

  useEffect(() => {
    localStorage.setItem("li_lang", lang);
    document.documentElement.lang = lang === "hi" ? "hi" : "en";
  }, [lang]);

  const t = (key) => (strings[lang] && strings[lang][key]) || (strings.en && strings.en[key]) || key;
  const L = (obj, base) => {
    if (!obj) return "";
    return obj[`${base}_${lang}`] || obj[`${base}_en`] || "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, L }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
